// Error display component for AI chat.
// Shows an error message with a retry button that dispatches ai-retry event.

import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import "./ErrorDisplay.style";

class ErrorDisplay extends PolymerElement {
  static get template() {
    return html`
      <style include="error-display-style"></style>
      <div class="ai-error" role="alert">
        <div>[[message]]</div>
        <button type="button" class="ai-error__btn" on-click="_retry">
          Coba lagi
        </button>
      </div>
    `;
  }

  static get properties() {
    return {
      message: {
        type: String,
        value: "Terjadi kendala. Silakan coba lagi.",
      },
    };
  }

  // Dispatch ai-retry event so the parent can clear error state
  _retry() {
    this.dispatchEvent(
      new CustomEvent("ai-retry", { bubbles: true, composed: true })
    );
  }
}

customElements.define("error-display", ErrorDisplay);
